(function () {
  'use strict';

  if (!/^\/pages\/(track-your-order|order-tracking)\/?$/.test(window.location.pathname)) return;

  var API_PATH = 'customerservice.basketsco.com/api/order/byOrderNumber';
  var INPUT_ID = 'giftsapp-tracking-order-number';
  var originalFetch = window.fetch.bind(window);

  function normalizedOrderNumber() {
    var input = document.getElementById(INPUT_ID);
    return input ? input.value.trim().replace(/^#/, '').toUpperCase() : '';
  }

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : resource && resource.url;
    if (url && url.indexOf(API_PATH) !== -1 && options && typeof options.body === 'string') {
      try {
        var body = JSON.parse(options.body);
        body.order_number = normalizedOrderNumber();
        options = Object.assign({}, options, { body: JSON.stringify(body) });
      } catch (_) {
        // Preserve the original request if its body is not JSON.
      }
    }
    return originalFetch(resource, options);
  };

  function installField() {
    var widget = Array.prototype.find.call(document.querySelectorAll('*'), function (element) {
      return element.tagName.toLowerCase().indexOf('order-tracking-') === 0;
    });
    if (!widget || document.getElementById(INPUT_ID)) return;

    var emailInput = widget.querySelector('input[type="email"]');
    var emailGroup = emailInput && emailInput.parentElement;
    if (!emailGroup) return;

    var group = emailGroup.cloneNode(true);
    var label = group.querySelector('label');
    var input = group.querySelector('input');

    label.setAttribute('for', INPUT_ID);
    label.textContent = 'Order Number';
    input.type = 'text';
    input.id = INPUT_ID;
    input.name = 'order_number';
    input.value = '';
    input.placeholder = window.location.hostname.indexOf('vancouver') !== -1 ? 'VBL123456' : 'TBL191960';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Order Number');
    input.required = true;

    emailGroup.parentElement.insertBefore(group, emailGroup);

    var button = widget.querySelector('button[aria-label="Track order"]');
    if (button) {
      button.addEventListener('click', function (event) {
        if (!input.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installField, { once: true });
  } else {
    installField();
  }
})();
